import { themeColours } from "./themeColours";
import { SEMANTIC_TOKEN_NAMES } from "./Colours";
import { applyAgGridColours } from "./applyAgGridColours";

// Live, in-browser-only preview for ThemeEditor.tsx. Chakra v2 (confirmed by inspecting a live
// page's computed styles) emits every semanticTokens colour as a real, inherited CSS custom
// property on :root - --chakra-colors-<token-name> - which is exactly what every "bg=navbar-bg"
// style prop compiles down to. Overwriting that property directly with
// document.documentElement.style.setProperty (inline :root style; always wins over the
// stylesheet Chakra generated at build time, regardless of import order) makes the ENTIRE running
// app repaint live, with no theme object, no React state, no re-render plumbing.
//
// This never touches source files or the server - it's a DOM mutation local to this one browser
// tab, so it is inherently scoped to "just this user, while this page is open" as asked. Call
// clearLiveThemeOverride() on unmount to fall back to the real compiled-in values from
// themeColours.ts once the user navigates away from /theme_editor.
export function applyLiveThemeOverride(colours: Record<keyof typeof themeColours, string>) {
  const root = document.documentElement;
  for (const key of Object.keys(SEMANTIC_TOKEN_NAMES) as (keyof typeof themeColours)[]) {
    root.style.setProperty(`--chakra-colors-${SEMANTIC_TOKEN_NAMES[key]}`, colours[key]);
  }
  applyAgGridColours(colours);
}

export function clearLiveThemeOverride() {
  applyLiveThemeOverride(themeColours);
}
